import { render } from "./initial-check.vue?vue&type=template&id=b2a51c1a"
import script from "./initial-check.vue?vue&type=script&lang=js"
export * from "./initial-check.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__